module.exports = __webpack_public_path__ + "static/media/stocking.8c327da5.svg";